import script from "./DetalleZallaNaturaView.vue?vue&type=script&setup=true&lang=js"
export * from "./DetalleZallaNaturaView.vue?vue&type=script&setup=true&lang=js"

import "./DetalleZallaNaturaView.vue?vue&type=style&index=0&id=3a7ec641&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a7ec641"]])

export default __exports__